export default __webpack_public_path__ + "static/media/increase-ctr.d7a48201.png";